import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Toast } from 'react-weui';
import PropTypes from 'prop-types';
import * as MobileActions from 'actions/index.ts';
import Http from 'services/http2';
import User from 'services/user2';

import { withStyles } from '@material-ui/core/styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const styles = theme => ({
  paper: {
    margin: '10px',
  },
});

class VerifyPartner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cpCode: '',
      cpName: '',
      errorMsg: '',
      inviteCode: '',
      inviteCompanyCode: '',
      companyList: [],
      showLoading: false,
    };
    this.intPattern = /^\d{6}$/;
    this.intPattern2 = /^[0-9]*$/;
  }

  init() {
    this.setState({ companyList: User.getCompanyList() });
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() {}

  handleClose = () => {
    const { actions } = this.props;
    actions.closeVerifyPartnerModal();
  };

  handleChange = event => {
    let val = event.target.value;
    this.setState({ [event.target.name]: val });
    this.setState({ errorMsg: '' });
    if (event.target.name === 'cpCode') {
      let cpName = this.state.companyList.filter(
        item => item.companyCode === val
      )[0].companyName;
      this.setState({ cpName: cpName });
      this.getInviteInfo();
    }
  };

  handleOk = () => {
    if (!this.check()) {
      return;
    }
    if (this.state.companyList.length > 1 && !this.state.cpCode) {
      this.setState({ errorMsg: '请先选择公司' });
      return;
    }
    let vendorCode;
    vendorCode =
      this.state.companyList.length > 1
        ? this.state.cpCode
        : this.state.companyList[0].companyCode;
    let postbody = {
      companyCode: this.state.inviteCompanyCode,
      inviteCode: this.state.inviteCode,
      vendorCode: vendorCode,
      apiPath: '/archives/compVendor/authInvite',
    };
    this.setState({ showLoading: true });
    Http.post('/api/cloudCenter?btnId=009', postbody).then(response => {
      this.setState({ showLoading: false });
      if (response.success) {
        this.setState({ inviteCode: '', inviteCompanyCode: '', errorMsg: '' });
        this.props.onChange('success');
        this.handleClose();
      } else {
        this.setState({ errorMsg: response.errorMsg });
      }
    });
  };

  check = () => {
    var result = true;
    if (
      this.state.inviteCompanyCode === '' ||
      !this.intPattern2.test(this.state.inviteCompanyCode)
    ) {
      this.setState({ errorMsg: '无效的携客企业号' });
      result = false;
    }
    if (!this.intPattern.test(this.state.inviteCode)) {
      this.setState({ errorMsg: '无效的验证码' });
      result = false;
    }
    return result;
  };

  getInviteInfo = () => {
    if (!this.state.inviteCompanyCode || !this.state.inviteCode) {
      return;
    }
    let postbody = {
      companyCode: this.state.inviteCompanyCode,
      inviteCode: this.state.inviteCode,
      apiPath: '/archives/compVendor/getInviteInfo',
    };
    Http.post('/api/cloudCenter?btnId=010', postbody).then(response => {
      if (response.success) {
        let data = response.data;
        //选择公司与客户邀请公司是否一致
        if (
          this.state.companyList.length > 1 &&
          this.state.cpCode &&
          this.state.cpName !== data.vendorNameByInvited
        ) {
          this.setState({
            errorMsg: `您选择的公司跟受邀公司“${data.vendorNameByInvited}”名称不一致，是否确认无误？`,
          });
        }
      }
    });
  };

  render() {
    const { classes, data } = this.props;
    return (
      <div>
        <Dialog
          classes={{ paper: classes.paper }}
          open={data.showReceiveInvite}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">接受客户邀请</DialogTitle>
          <DialogContent>
            <TextField
              margin="normal"
              variant="outlined"
              id="inviteCompanyCode"
              name="inviteCompanyCode"
              label="输入邀请信息中的携客企业号"
              onChange={this.handleChange}
              type="inviteCompanyCode"
              fullWidth
            />

            <TextField
              margin="normal"
              variant="outlined"
              id="inviteCode"
              name="inviteCode"
              label="输入邀请信息的6位数验证码"
              onChange={this.handleChange}
              type="inviteCode"
              fullWidth
            />

            {this.state.companyList.length && (
              <FormControl
                variant="outlined"
                className={classes.formControl}
                margin="normal"
                fullWidth
              >
                <InputLabel htmlFor="outlined-age-simple">选择公司</InputLabel>
                <Select
                  value={this.state.cpCode}
                  onChange={this.handleChange}
                  input={
                    <OutlinedInput
                      labelWidth={70}
                      name="cpCode"
                      id="outlined-cpCode-simple"
                    />
                  }
                >
                  {this.state.companyList.map((item, index) => (
                    <MenuItem key={index} value={item.companyCode}>
                      {item.companyName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            {this.state.errorMsg && (
              <p className="error-tip">{this.state.errorMsg}</p>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              取消
            </Button>
            <Button onClick={this.handleOk} color="primary">
              确定
            </Button>
          </DialogActions>
        </Dialog>
        <Toast icon="loading" show={this.state.showLoading}>
          Loading...
        </Toast>
      </div>
    );
  }
}

VerifyPartner.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.modal,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(VerifyPartner));
